import { createListenerMiddleware } from '@reduxjs/toolkit';
import { searchAttendeesByEvent } from 'src/redesign/features/Attendees/store/actions';
import { searchAttendeesStatsByEvent } from 'src/redesign/features/AttendeeStats/actions';
import { eventsFiltersSlice } from '../../EventsFilters/reducer';
import { fetchEventAttendeesFilterValues } from '../../EventsFilters/actions';

export const listenerMiddleware = createListenerMiddleware();

// Listener for initial page load - when filter values are fetched
listenerMiddleware.startListening({
  actionCreator: fetchEventAttendeesFilterValues.fulfilled,
  effect: async (_, listenerApi) => {
    const filters = listenerApi.getState()?.eventsFilters?.filtersData;
    const eventId = listenerApi.getState()?.events.currentEvent?.id;

    // Only dispatch if eventId exists to prevent unnecessary API calls
    if (!eventId) {
      console.warn('[Initial Load] Stats and search calls skipped: eventId is missing');
      return;
    }

    console.log('[Initial Load] Fetching stats and attendees for eventId:', eventId);

    // Call stats and search in parallel for faster response
    await Promise.all([
      listenerApi.dispatch(searchAttendeesStatsByEvent({ eventId, criteria: filters })),
      listenerApi.dispatch(searchAttendeesByEvent({ eventId, criteria: filters })),
    ]);
  },
});

// Listener for filter changes - when user changes filters
listenerMiddleware.startListening({
  actionCreator: eventsFiltersSlice.actions.setFiltersData,
  effect: async (_, listenerApi) => {
    const filters = listenerApi.getState()?.eventsFilters?.filtersData;
    const eventId = listenerApi.getState()?.events.currentEvent?.id;

    // Only dispatch if eventId exists to prevent unnecessary API calls
    if (!eventId) {
      console.warn('[Filter Change] Stats and search calls skipped: eventId is missing');
      return;
    }

    console.log('[Filter Change] Refreshing stats and attendees for eventId:', eventId);

    // Call stats and search in parallel for faster response
    await Promise.all([
      listenerApi.dispatch(searchAttendeesStatsByEvent({ eventId, criteria: filters })),
      listenerApi.dispatch(searchAttendeesByEvent({ eventId, criteria: filters })),
    ]);
  },
});
